import React from 'react'
import { withIcon } from '../../withIcon'
// eslint-disable-next-line import/no-unresolved
import archetypeSvg from './archetype-mystic.svg'

function ArchetypeMysticIcon (props) {
  const { size = '100px', alt = '' } = props

  return (
    <img
      src={archetypeSvg}
      alt={alt}
      width={size}
      height={size}
      style={{ display: 'block', borderRadius: '50%' }}
    />
  )
}

export default withIcon(ArchetypeMysticIcon)
